import React, { useContext } from 'react';
import useSearchParams from '../hooks/useSearchParams';

const LanguageContext = React.createContext();

const useLanguageContext = () => useContext(LanguageContext);

const { Provider, Consumer } = LanguageContext;

const LanguageProvider = ({ children }) => {
  const isPilotRoute = window?.location?.href?.includes('/login');

  const validateLanguage = (value) => value
  && typeof value == 'string' && /^\w{2}-\w{2}$/i.test(value)
  && (isPilotRoute || (!isPilotRoute && isValidLanguage(null, value)))

  const defaultLanguage = isPilotRoute ? getLocaleLanguage() : 'en-US';

  const [lang, setSearchParams] = useSearchParams('lang', defaultLanguage, validateLanguage);

  const context = { language : { locale: lang || 'en-US' } ,  setLanguage: ({locale}) => setSearchParams(locale) };
  return <Provider value={context}>{children}</Provider>;
};

function getCountryInfoByLocale(regions, locale) {
  let countryInfo;
  let defaultCountry;

  regions.forEach((region, regionIndex) => {
    if (region.subregions) {
      region.subregions.forEach(subregion => {
        subregion.countries.forEach(country => {
          country.languages.forEach(language => {
            if (language.locale.toUpperCase() === locale.toUpperCase()) {
              countryInfo = { country, regionIndex, languageTitle: language.title };
            } else if (language.locale.toUpperCase() === 'EN-US') {
              defaultCountry = { country, regionIndex, languageTitle: language.title };
            }
          });
        });
      });
    }
  });

  return countryInfo || defaultCountry;
};

function isValidLanguage(regions, lang) {
  let isValid = false;

  if ('en-us, ca-en, ca-fr, en-ca, fr-ca'.includes(lang?.toLowerCase())) return true;

  if (regions?.length)
    regions.forEach(region => {
      if (region.subregions) {
        region.subregions.forEach(subregion => {
          subregion.countries.forEach(country => {
            country.languages.forEach(language => {
              if (language?.locale?.toUpperCase() === lang?.toUpperCase()) {
                isValid = true;
                return true;
              }
            });
          });
        });
      }
    });

  return isValid;
};

function getLocaleLanguage() {
  let language;
  if (window?.navigator?.languages?.[0]) {
    language = window.navigator.languages[0];
  } else {
    language = window?.navigator?.userLanguage || window?.navigator?.language;
  }
  return language ?? 'en-us';
}

export { LanguageProvider, Consumer as ConsumerProvider, getCountryInfoByLocale, isValidLanguage, useLanguageContext };
export default LanguageContext;
